"use client";

import { Skeleton } from "@texturehq/edges";

export function AppShellSkeleton() {
  return (
    <div className="flex h-screen bg-background">
      {/* Left sidebar skeleton - Desktop only */}
      <div className="hidden md:flex w-64 border-r border-border-default flex-col">
        {/* Logo area with hamburger */}
        <div className="h-16 border-b border-border-default flex items-center justify-between px-4">
          <Skeleton height={32} width={128} />
          <Skeleton height={24} width={24} />
        </div>

        {/* Navigation items */}
        <div className="flex-1 p-4 space-y-2">
          {Array.from({ length: 8 }, (_, index) => `nav-item-${index}`).map((key) => (
            <div key={key} className="flex items-center space-x-3 h-10 px-3">
              <Skeleton height={20} width={20} />
              <Skeleton height={16} width="100%" />
            </div>
          ))}
        </div>

        {/* Bottom workspace switcher skeleton */}
        <div className="border-t border-border-default p-4">
          <div className="flex items-center space-x-3 h-12 px-3">
            <Skeleton height={32} width={32} variant="circle" />
            <div className="flex-1">
              <Skeleton height={12} width={96} className="mb-1" />
              <Skeleton height={8} width={64} />
            </div>
          </div>
        </div>
      </div>

      {/* Main content area */}
      <div className="flex-1 flex flex-col">
        {/* Top header skeleton */}
        <div className="h-16 border-b border-border-default flex items-center justify-between px-6">
          {/* Left section - Hamburger menu on mobile */}
          <div className="md:hidden flex items-center border-r border-border-default pr-6 -ml-6 pl-6">
            <Skeleton height={32} width={32} />
          </div>

          {/* Right section - User avatar */}
          <div className="flex items-center space-x-4 md:ml-auto">
            <Skeleton height={32} width={32} variant="circle" />
            <Skeleton height={32} width={32} variant="circle" />
          </div>
        </div>

        {/* Content area - Single skeleton */}
        <div className="flex-1 overflow-auto flex justify-center px-4 py-8 md:py-12">
          <div className="w-full" style={{ maxWidth: "1400px" }}>
            <Skeleton height="100%" width="100%" />
          </div>
        </div>
      </div>
    </div>
  );
}
